import React from 'react';

const ThankYouCustomQuiz = ({ title, buttonLabel, onSubmit, isLoading }) => (
  <div className="t-flex t-flex-col t-items-center t-justify-center t-min-h-[60vh] t-gap-4 t-text-center">
    <p className="t-m-0 t-text-navy t-text-xl t-font-sans">{title}</p>
    <button
      type="button"
      onClick={onSubmit}
      disabled={isLoading}
      className="t-px-8 t-py-3 t-rounded-xl t-bg-quiz-teal t-text-white t-font-sans t-font-bold t-text-base t-border-0 t-cursor-pointer hover:t-bg-[#0e5c5d] disabled:t-opacity-50"
    >
      {buttonLabel}
    </button>
  </div>
);

export default ThankYouCustomQuiz;

